const findEntry = (crossMap, space, edge, pos, includeBond = true) => {
    return crossMap.find(item =>
        item[space]?.[edge] === pos && (includeBond || !item.bond)
    ) ?? null;
}

const lookup = (crossMap, pos, { from, to, edge, includeBond = true }) => {
    return findEntry(crossMap, from, edge, pos, includeBond)?.[to]?.[edge] ?? null;
}

const lookupRange = (crossMap, { start, end }, { from, to, includeBond = true }) => {
    const s = lookup(crossMap, start, { from, to, edge: "start", includeBond });
    const e = lookup(crossMap, end,   { from, to, edge: "end",   includeBond });
    return (s === null || e === null) ? null : { start: s, end: e };
}

const lookupSelection = (crossMap, { start, end }, { from, to, includeBond = true }) => {
    if (start === end) {
        const pos = lookup(crossMap, start, { from, to, edge: "start", includeBond })
            ?? crossMap[crossMap.length - 1]?.[to]?.start
            ?? null;
        return pos === null ? null : { start: pos, end: pos };
    }
    return lookupRange(crossMap, { start, end }, { from, to, includeBond });
}

const findEntryByRange = (crossMap, { start, end }, space, includeBond = true) => {
    return crossMap.find(item =>
        item[space]?.start === start &&
        item[space]?.end === end &&
        (includeBond || !item.bond)
    ) ?? null;
}

export {
    findEntry,
    lookup,
    lookupRange,
    lookupSelection,
    findEntryByRange
}